import React from 'react';
import {Link} from 'react-router-dom';
import {Popup} from 'semantic-ui-react';

const PartsOrdersIcon = ({campaingNo, part, isUserTde, inactiveCampaign}) => {
  const path = part ?
    `/pedidos-campana/${campaingNo}/partes/${part}` :
    `/pedidos-campana/${campaingNo}/partes`;

  if (!isUserTde || inactiveCampaign) {
    return null;
  }

  return (
    <Popup
      trigger={
        <Link to={path} target='_blank'>
          <span className='link'>
            <i className='material-icons'>
              car_rental
            </i>
          </span>
        </Link>
      }
      content='Pedidos partes'
      position='top center'
      inverted
    />
  );
};

export default PartsOrdersIcon;
